// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ol6y","fullView":"styles_fullView__GSiee"};